{
  "deprecatedBrowser": "お使いのブラウザーはサポートされていません",
  "deprecatedBrowserHelpText": "最高のエクスペリエンスを得るために、ブラウザーを最新バージョンにアップデートすることを検討してください。"
}
